import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth';

export const Route = createFileRoute('/recipes')({
  component: ProtectedRecipesLayout,
});

function ProtectedRecipesLayout() {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
}
